/**
 * An enum of values relating to (non-exclusive) product groups.
 */
export enum SALES_DOCUMENT_TYPE_ID {
  CONTRACT = 1,
  SALES_ORDER = 2,
  TOP_PRODUCTS = 3,
  REGIONAL_PRODUCTS = 4,
  APPROVED_PRODUCTS = 5,
  COUNTRY_PRODUCTS = 6,
  ADDITIONAL_SERVICES = 8,
}

export type SalesDocumentTypeIdType =
  | SALES_DOCUMENT_TYPE_ID.CONTRACT
  | SALES_DOCUMENT_TYPE_ID.SALES_ORDER
  | SALES_DOCUMENT_TYPE_ID.TOP_PRODUCTS
  | SALES_DOCUMENT_TYPE_ID.REGIONAL_PRODUCTS
  | SALES_DOCUMENT_TYPE_ID.APPROVED_PRODUCTS
  | SALES_DOCUMENT_TYPE_ID.COUNTRY_PRODUCTS
  | SALES_DOCUMENT_TYPE_ID.ADDITIONAL_SERVICES;
